import { GROUP_TYPES } from "../types/dist/constants.js";
import { Type } from "js-yaml";
import { CUSTOM_TAGS } from "../constants.js";
import { shortHash } from "../utils/hash.js";
const represent = (data) => {
  const {
    id,
    width,
    height,
    maxHeight,
    maxWidth,
    isGrouped,
    isVertical,
    content,
    conditions,
    colorScheme
  } = data;
  return {
    content,
    grouped: isGrouped,
    vertical: isVertical,
    id: id?.startsWith("$tmp:") ? void 0 : id,
    width,
    height,
    "max-height": maxHeight,
    "max-width": maxWidth,
    "color-scheme": colorScheme,
    conditions: conditions ? conditions : void 0
  };
};
class ParsedContainer {
  id;
  maxHeight;
  conditions;
  maxWidth;
  width;
  height;
  colorScheme;
  isGrouped;
  isVertical;
  content;
  type = GROUP_TYPES.container;
  constructor(parsedContainer) {
    this.id = parsedContainer.id || `$tmp:${shortHash(JSON.stringify(parsedContainer))}`;
    this.isGrouped = "grouped" in parsedContainer ? parsedContainer.grouped : void 0;
    this.isVertical = "vertical" in parsedContainer ? parsedContainer.vertical : void 0;
    this.conditions = parsedContainer.conditions || void 0;
    this.width = parsedContainer.width || void 0;
    this.height = parsedContainer.height || void 0;
    this.maxHeight = parsedContainer["max-height"] || void 0;
    this.maxWidth = parsedContainer["max-width"] || void 0;
    this.colorScheme = parsedContainer["color-scheme"] || void 0;
    this.content = parsedContainer.content || [];
  }
}
const ContainerTag = new Type(CUSTOM_TAGS.CONTAINER, {
  kind: "mapping",
  resolve: (data) => data !== null,
  construct: (data) => new ParsedContainer(data),
  instanceOf: ParsedContainer,
  represent
});
export {
  ContainerTag,
  ParsedContainer
};
